import { useSearchParams } from 'react-router-dom';
import PublicLayout from '../layouts/PublicLayout';
import Menu from './Menu';
import Landing from './Landing';

/**
 * Raiz do site: com restaurante/mesa no query string é o CARDÁPIO público do
 * estabelecimento; sem nada, a LANDING de venda da plataforma.
 */
export default function Home() {
  const [params] = useSearchParams();
  const temRestaurante = params.get('restaurante');
  const temMesa = params.get('mesa');

  if (temRestaurante || temMesa) {
    return (
      <PublicLayout>
        <Menu />
      </PublicLayout>
    );
  }

  return <Landing />;
}